import { confirmModalStructure } from './confirmModalStructure'
import { modalStructure } from './modalStructure'

export default ({ 
    confirmModalStructure,
    modalStructure
})
